'use client'

import { useState, useEffect } from 'react'
import parse from 'html-react-parser'
import Spin from 'components/Spin'

const TableStaticPagination = ({
  headers,
  content,
  cols,
  extraClass,
  withTitle,
  setOnClick,
  type,
  headersMobile,
  contentMobile,
  colsMobile,
  extraClassHeaderMobile,
  extraClassMobile,
  forceRowsInMobile = false,
  resultsByPage = 5,
  keyOnHeaderMobile = '',
  additionalData = {},
  loading
}) => {
  // const pagination = { resultsByPage: 5 }
  // const { resultsByPage } = pagination
  const [pages, setPages] = useState([0])
  const [elements, setElements] = useState(0)
  const [pageCount, setPageCount] = useState('0-0')
  const [pageDynamically, setPageDynamically] = useState(1)
  const currentCount = pageDynamically * resultsByPage - resultsByPage + 1
  const showPagination = content.length > resultsByPage
  const [mobileHeaderStatic, mobileHeaderDynamic] = keyOnHeaderMobile.split('.')

  useEffect(() => {
    setElements(content.length)
    const pagesSelect = Array.from(
      {
        length: Math.ceil(content.length / resultsByPage)
      },
      (_, i) => ({
        page: i + 1,
        selected: i + 1 === pageDynamically
      })
    )
    setPages(pagesSelect)
    setPageCount(
      `${currentCount > 0 ? currentCount : 0}-${
        parseInt(pageDynamically) === pagesSelect.length
          ? content.length
          : pageDynamically * resultsByPage
      }`
    )
  }, [pageDynamically, content])

  return (
    <>
      <div className={`${!withTitle ? 'my-10 lg:my-16' : ''}`}>
        {!forceRowsInMobile ? (
          <div className="block lg:hidden">
            <div>
              {loading ? (
                <div className="flex justify-center my-8">
                  <Spin color="text-blue" size="8" />
                </div>
              ) : (
                content
                  .slice(
                    (pageDynamically - 1) * resultsByPage,
                    (pageDynamically - 1) * resultsByPage + resultsByPage
                  )
                  ?.map((item, idx) => {
                    const lastItem = item[Object.keys(item).length - 1]
                    const headersCleaned = headers.filter((i) => i)
                    return (
                      <>
                        <div className="bg-blue text-white text-[18px] font-alliance-light rounded-t-md py-4 pl-4 text-center">
                          {`${mobileHeaderStatic}${
                            item?.[mobileHeaderDynamic]
                              ? ` ${item?.[mobileHeaderDynamic]}`
                              : ''
                          }`}
                        </div>
                        <div
                          key={idx}
                          className="grid grid-cols-1 text-blue font-alliance-medium text-[15px] mb-10"
                        >
                          {Object.keys(item)
                            ?.filter(
                              (key) =>
                                !`${item[key]}`.includes('link') &&
                                !`${item[key]}`.includes('id:') &&
                                key !== mobileHeaderDynamic
                            )
                            .map((key, sidx) => (
                              <>
                                <div
                                  key={sidx}
                                  className={`grid grid-cols-2 lg:grid-cols-${cols} border-blue border-b border-opacity-10 hover:bg-blue hover:bg-opacity-10 hover:rounded-md`}
                                  data-id={`${lastItem}`?.replace('id:', '')}
                                >
                                  <div className="font-alliance-bold py-2 ml-4">
                                    {headersCleaned[sidx]
                                      ? `${headersCleaned[sidx]}:`
                                      : ''}
                                  </div>
                                  <div className="grid py-2 ml-2 mr-2">
                                    {item[key]}
                                  </div>
                                </div>
                              </>
                            ))}
                        </div>
                      </>
                    )
                  })
              )}
            </div>
          </div>
        ) : (
          <div
            className={`block lg:hidden ${
              type === 'center' ? 'text-center' : ''
            }`}
          >
            <div
              className={`grid ${
                type !== 'center' ? `grid-cols-${colsMobile}` : ''
              } bg-blue text-white text-[15px] font-alliance-light rounded-t-md py-6 pl-2 text-center`}
            >
              {headersMobile.map((item, idx) => {
                return (
                  <div className={extraClassHeaderMobile?.[idx]} key={idx}>
                    {item}
                  </div>
                )
              })}
            </div>
            <div>
              {contentMobile
                .slice(
                  (pageDynamically - 1) * resultsByPage,
                  (pageDynamically - 1) * resultsByPage + resultsByPage
                )
                .map((item, idx) => {
                  const lastItem = item[Object.keys(item).length - 1]
                  const hasLink = `${lastItem}`.includes('link')
                  return (
                    <div
                      key={idx}
                      className={`relative grid grid-cols-${colsMobile} text-blue font-alliance-medium pl-2 py-2 text-[15px] border-blue border-b border-opacity-10 hover:bg-blue hover:bg-opacity-10 hover:rounded-md items-center text-center ${
                        (hasLink || setOnClick) && 'hover:cursor-pointer'
                      }`}
                      onClick={setOnClick}
                    >
                      {Object.keys(item)
                        ?.filter(
                          (key) =>
                            !`${item[key]}`.includes('link') &&
                            !`${item[key]}`.includes('id:')
                        )
                        .map((key, sidx) => (
                          <div
                            key={sidx}
                            className={extraClassMobile?.[sidx] || ''}
                            data-id={`${lastItem}`?.replace('id:', '')}
                          >
                            {`${item[key]}`.includes('circle:') ? (
                              <div className="bg-sec-red rounded-full w-8 h-8 flex justify-center items-center">
                                {item[key].replace('circle:', '')}
                              </div>
                            ) : `${item[key]}`.includes('color') &&
                              !`${item[key]}`.includes('colors') ? (
                              <>
                                <div
                                  className="absolute w-1 h-full top-0 left-0"
                                  style={{
                                    backgroundColor:
                                      additionalData.FirstColumn?.[idx].Color
                                  }}
                                ></div>
                                <div
                                  className="absolute w-1 h-full top-0 left-1"
                                  style={{
                                    backgroundColor:
                                      additionalData.SecondColumn?.[idx].Color
                                  }}
                                ></div>
                                <div
                                  className="absolute w-1 h-full top-0 left-2"
                                  style={{
                                    backgroundColor:
                                      additionalData.ThirdColumn?.[idx].Color
                                  }}
                                ></div>
                                {additionalData.pending?.[idx] ? (
                                  <div className="absolute h-full left-[13px] font-bold flex items-center">
                                    !
                                  </div>
                                ) : (
                                  ''
                                )}
                              </>
                            ) : isNaN(item[key]) &&
                              typeof item[key] === 'string' ? (
                              parse(item[key])
                            ) : (
                              item[key]
                            )}
                          </div>
                        ))}
                    </div>
                  )
                })}
            </div>
          </div>
        )}
        <div
          className={`hidden lg:block ${
            type === 'center' ? 'text-center' : ''
          }`}
        >
          <div
            className={`grid ${
              type !== 'center' ? `grid-cols-${cols}` : ''
            } bg-blue text-white text-[15px] font-alliance-light rounded-t-md py-6 pl-6`}
          >
            {headers.map((item, idx) => {
              return <div key={idx}>{item}</div>
            })}
          </div>
          <div>
            {loading ? (
              <div className="flex justify-center my-8">
                <Spin color="text-blue" size="8" />
              </div>
            ) : (
              content
                .slice(
                  (pageDynamically - 1) * resultsByPage,
                  (pageDynamically - 1) * resultsByPage + resultsByPage
                )
                .map((item, idx) => {
                  const lastItem = item[Object.keys(item).length - 1]
                  const hasLink = `${lastItem}`.includes('link')
                  return (
                    <div
                      key={idx}
                      className={`relative grid grid-cols-${cols} text-blue font-alliance-medium pl-6 py-6 text-[15px] border-blue border-b border-opacity-10 hover:bg-blue hover:bg-opacity-10 hover:rounded-md items-center ${
                        (hasLink || setOnClick) && 'hover:cursor-pointer'
                      }`}
                      onClick={setOnClick}
                    >
                      {Object.keys(item)
                        ?.filter(
                          (key) =>
                            !`${item[key]}`.includes('link') &&
                            !`${item[key]}`.includes('id:')
                        )
                        .map((key, sidx) => (
                          <div
                            key={sidx}
                            className={extraClass?.[sidx] || ''}
                            data-id={`${lastItem}`?.replace('id:', '')}
                          >
                            {`${item[key]}`.includes('circle:') ? (
                              <div className="bg-sec-red rounded-full w-8 h-8 flex justify-center items-center">
                                {item[key].replace('circle:', '')}
                              </div>
                            ) : `${item[key]}`.includes('color') &&
                              !`${item[key]}`.includes('colors') ? (
                              <>
                                <div
                                  className="absolute w-2 h-full top-0 left-0"
                                  style={{
                                    backgroundColor:
                                      additionalData.FirstColumn?.[idx].Color
                                  }}
                                ></div>
                                <div
                                  className="absolute w-2 h-full top-0 left-2"
                                  style={{
                                    backgroundColor:
                                      additionalData.SecondColumn?.[idx].Color
                                  }}
                                ></div>
                                <div
                                  className="absolute w-2 h-full top-0 left-4"
                                  style={{
                                    backgroundColor:
                                      additionalData.ThirdColumn?.[idx].Color
                                  }}
                                ></div>
                                {additionalData.pending?.[idx] ? (
                                  <div className="absolute h-full left-8 font-bold flex items-center">
                                    !
                                  </div>
                                ) : (
                                  ''
                                )}
                              </>
                            ) : isNaN(item[key]) &&
                              typeof item[key] === 'string' ? (
                              parse(item[key])
                            ) : (
                              item[key]
                            )}
                          </div>
                        ))}
                    </div>
                  )
                })
            )}
          </div>
        </div>

        {showPagination && !loading && (
          <div className="flex bg-sec-grey-4 bg-opacity-70 mt-8 lg:mt-16 justify-between lg:h-[72px] lg:pl-8 lg:pr-12 px-4">
            <div className="grid content-center">
              <p className="text-blue font-alliance-medium text-[12px] lg:text-[15px]">
                {`${pageCount} de ${elements}`}
              </p>
            </div>
            <div className="grid content-center">
              <div className="flex">
                <p className="grid content-center text-blue opacity-30 text-[12px] lg:text-[15px] font-alliance-medium mr-2 lg:mr-4">
                  Estàs a la página
                </p>
                <select
                  className="border-none rounded-md text-[12px] lg:text-[15px] font-alliance-medium mr-3 lg:mr-16 focus:ring-0 my-2 lg:my-0"
                  onChange={(e) => {
                    setPageDynamically(e.target.value)
                  }}
                >
                  {pages.map((item, idx) => (
                    <option key={idx} selected={item.selected}>
                      {item.page}
                    </option>
                  ))}
                </select>
                <button
                  onClick={() => {
                    if (pageDynamically - 1 > 0) {
                      setPageDynamically(pageDynamically - 1)
                    }
                  }}
                  className="group grid bg-white content-center px-4 rounded-md mr-1 lg:mr-3 hover:bg-blue hover:text-white hover:cursor-pointer my-2 lg:my-0"
                >
                  <div>
                    <img
                      src={`/assets/icons/arrow-mini-left.svg`}
                      alt="left"
                      className="block group-hover:hidden"
                    />
                    <img
                      src={`/assets/icons/arrow-mini-left-white.svg`}
                      alt="left"
                      className="hidden group-hover:block"
                    />
                  </div>
                </button>
                <div className="border-l-2 border-blue border-opacity-10 my-4 lg:my-1"></div>
                <button
                  onClick={() => {
                    if (pageDynamically + 1 <= pages.length) {
                      setPageDynamically(pageDynamically + 1)
                    }
                  }}
                  className="group grid bg-white content-center px-4 rounded-md ml-1 lg:ml-3 hover:bg-blue hover:text-white hover:cursor-pointer my-2 lg:my-0"
                >
                  <div>
                    <img
                      src={`/assets/icons/arrow-mini-right.svg`}
                      alt="right"
                      className="block group-hover:hidden pointer-events-none"
                    />
                    <img
                      src={`/assets/icons/arrow-mini-right-white.svg`}
                      alt="right"
                      className="hidden group-hover:block pointer-events-none"
                    />
                  </div>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default TableStaticPagination
